import {
  RegularTaskReportStateTypes,
  RegularTaskReportActionTypes,
} from "./RegularTaskReport.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: RegularTaskReportStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const RegularTaskReportReducer = (
  state: RegularTaskReportStateTypes = INITIAL_STATE,
  action: any
): RegularTaskReportStateTypes => {
  switch (action.type) {
    case RegularTaskReportActionTypes.FETCH_ALL_REGULAR_TASK_REPORT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case RegularTaskReportActionTypes.FETCH_ALL_REGULAR_TASK_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case RegularTaskReportActionTypes.FETCH_ALL_REGULAR_TASK_REPORT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case RegularTaskReportActionTypes.FETCH_ALL_REGULAR_TASK_REPORT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case RegularTaskReportActionTypes.FETCH_ONE_REGULAR_TASK_REPORT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case RegularTaskReportActionTypes.FETCH_ONE_REGULAR_TASK_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case RegularTaskReportActionTypes.FETCH_ONE_REGULAR_TASK_REPORT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case RegularTaskReportActionTypes.FETCH_ONE_REGULAR_TASK_REPORT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default RegularTaskReportReducer;
